module.exports = __webpack_public_path__ + "img/mail_icon.006234cb.png";